import CustomModal from "../CustomModal";
import React, { useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { translate } from "../../Services/translation";

export default function ConfigurableProductModal(props) {
    const { register, handleSubmit, control, getValues, comment, formState: { errors } } = useForm({
        defaultValues: {
            items: [{ name: '', quantity: '1' }],
        },
    });

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'items',
    });

    const onSubmit = (data) => {
        props.onSubmit(data.items);
        props.setClose();
    };

    const validateQuantityGreaterThanZero = (value) => {
        const intValue = parseInt(value);
        return intValue > 0 || translate('forms.quantitycannotbezero');
    };

    return (
        <CustomModal isOpen={props.open}
                     onClose={() => props.setClose()}
                     title={translate('product.configurable.title')}
                     description={translate('product.configurable.description')}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                {fields.map((item, index) => (
                    <div key={item.id} style={{ display: 'flex', marginBottom: '10px', alignItems: 'start' }}>
                        <div style={{ marginRight: '4px' }}>
                            <input
                                {...register(`items[${index}].name`, {
                                    required: translate('forms.required')
                                })}
                                defaultValue={item.name}
                                placeholder= {translate('product.configurable.name.placeholder')}
                            />
                            {errors?.items?.[index]?.name && <p className="modal__error-message">{errors.items[index].name.message}</p>}

                        </div>

                        <div>
                            <input
                                {...register(`items[${index}].quantity`,{
                                    required: true,
                                    validate: validateQuantityGreaterThanZero
                                })}
                                type="number"
                                defaultValue={item.quantity}
                                placeholder= {translate('product.configurable.quantity.placeholder')}
                            />
                            {errors?.items?.[index]?.quantity && <p className="modal__error-message">{errors.items[index].quantity.message}</p>}
                        </div>

                        {
                            fields.length > 1 && <button className="modal__remove-button" type="button" onClick={() => remove(index)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M2.5 5H4.16667H17.5" stroke="#373D41" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M15.8334 5.00033V16.667C15.8334 17.109 15.6578 17.5329 15.3453 17.8455C15.0327 18.1581 14.6088 18.3337 14.1667 18.3337H5.83341C5.39139 18.3337 4.96746 18.1581 4.6549 17.8455C4.34234 17.5329 4.16675 17.109 4.16675 16.667V5.00033M6.66675 5.00033V3.33366C6.66675 2.89163 6.84234 2.46771 7.1549 2.15515C7.46746 1.84259 7.89139 1.66699 8.33341 1.66699H11.6667C12.1088 1.66699 12.5327 1.84259 12.8453 2.15515C13.1578 2.46771 13.3334 2.89163 13.3334 3.33366V5.00033" stroke="#373D41" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M8.33325 9.16699V14.167" stroke="#373D41" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M11.6667 9.16699V14.167" stroke="#373D41" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>
                        }

                    </div>
                ))}


                {comment &&
                    <div className="modal__notice-container">
                        <p className="modal__notice-text">{comment}</p>
                    </div>
                }

								<button
                    className="modal__text-button"
                    type="button"
                    onClick={() => append({ name: '', quantity: "1" })}
                >
                    {translate('product.configurable.add.new')}
                </button>

                <br/>

                <button
                    className="modal__submit-button"
                    type="submit"
                >
                    {translate('product.configurable.submit')}
                </button>
            </form>
        </CustomModal>
    )
}
